import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { routesV3 } from 'src/app/layout-v3/shared/const/routes-config';
import { AuthService } from '../services';

 // Ajusta la ruta según tu proyecto

@Injectable({
  providedIn: 'root'
})
export class ActivateGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

   canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(!this.authService.isLoggedIn){
          const loginRoute = this.authService.getRedirectLoginRoute();
           return this.router.navigate([loginRoute]); 
        } else return true;     
   }
}